import config from '../config';

export const fullImage = (path: string) => path.replace(/(\.[^.]+)$/, `-full$1`);
export const thumbnail = (path: string) => path.replace(/(\.[^.]+)$/, `-thumbnail$1`);
export const blurred = (path: string) => path.replace(/(\.[^.]+)$/, `-blurred$1`);
export const imgUrl = (tripId: string, basename: string) => {
  return `${config.media.cdnUrl}/${tripId}/${basename.replace(/^\//, '')}`;
};
